import { BreakpointSize } from "@dvs/data-access";
import { createContext } from "react";

type Props = { breakpoint: BreakpointSize; isSmallScreen: boolean };
export const Context = createContext<Props>(undefined);
